import { useContext } from "react";
import translate from "../locales";
import { Question } from "../components/form/question";
import { Select } from "../components/form/select";
import { Option } from "../components/form/select-option";
import { InputGroup } from "../components/form/input-group";
import { ExercisePage } from "../components/exercise-page";
import { ClassroomContext } from "../components/classroom.context";

export function ExercisePageLegal1({ onPrevious, onNext }) {
  const { requireFields } = useContext(ClassroomContext);

  return (
    <ExercisePage
      title="exercise.legal_1.title"
      description="exercise.legal_1.description"
      labelPrevious="exercise.legal_1.button-previous"
      labelNext="exercise.legal_1.button-next"
      showSources
      onPrevious={onPrevious}
      onNext={onNext}
      buttonNextDisabled={
        !requireFields([
          "assessment",
          "distinction",
          "proportion",
          "precaution",
        ])
      }
    >
      <title>{translate("exercise.legal_1.page-title")}</title>
      <div className="exercise-card">
        {["distinction", "proportion", "precaution", "assessment"].map(
          (name, i) => (
            <Question
              key={name}
              question={`exercise.legal_1.question_${i + 1}.question`}
              description={`exercise.legal_1.question_${i + 1}.description`}
            >
              <InputGroup>
                <Select horizontal name={name}>
                  <Option description={true}>
                    <svg
                      width="61"
                      height="61"
                      viewBox="0 0 61 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.5 5.5C23.8695 5.5 17.5105 8.134 12.8225 12.8225C8.1342 17.511 5.5 23.87 5.5 30.5C5.5 37.13 8.134 43.4895 12.8225 48.1775C17.511 52.8658 23.87 55.5 30.5 55.5C37.13 55.5 43.4895 52.866 48.1775 48.1775C52.8658 43.489 55.5 37.13 55.5 30.5C55.4895 23.873 52.8521 17.52 48.166 12.834C43.4799 8.14785 37.127 5.5105 30.5 5.5ZM40.15 24.3L31.825 38.05C31.0405 39.417 29.6436 40.3203 28.075 40.475C27.9176 40.4957 27.7588 40.5041 27.6 40.5C26.2236 40.4943 24.9146 39.9033 24 38.875C23.925 38.775 23.85 38.7 23.775 38.6L20.925 34.4C20.4248 33.6586 20.3582 32.7069 20.75 31.903C21.142 31.0993 21.933 30.5655 22.825 30.503C23.7172 30.4405 24.5748 30.8586 25.075 31.6L27.7 35.5L35.85 21.7C36.1947 21.1297 36.7519 20.7199 37.399 20.5605C38.0459 20.4012 38.7297 20.5053 39.3 20.85C39.8703 21.1947 40.2801 21.752 40.4394 22.399C40.5988 23.0459 40.4947 23.7297 40.15 24.3Z"
                        fill="#0081FF"
                      />
                    </svg>
                  </Option>

                  <Option description={false}>
                    <svg
                      width="61"
                      height="61"
                      viewBox="0 0 61 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath={`url(#clip0-${name})`}>
                        <path
                          d="M12.8222 12.8223C8.13373 17.5108 5.49976 23.8698 5.50011 30.5C5.50025 37.1304 8.13408 43.4896 12.8222 48.1777C17.5103 52.8658 23.8697 55.5001 30.4999 55.4998C37.1303 55.4996 43.4894 52.8658 48.1775 48.1777C52.8657 43.4896 55.5 37.1302 55.4996 30.5C55.4995 23.8696 52.8657 17.5104 48.1775 12.8223C43.4841 8.14379 37.127 5.5164 30.4999 5.5165C23.8727 5.5165 17.5156 8.14376 12.8222 12.8223ZM39.3387 25.1967L34.0354 30.5L39.3387 35.8033C39.9703 36.4349 40.2169 37.3555 39.9857 38.2181C39.7547 39.0809 39.0807 39.7548 38.218 39.9859C37.3554 40.2171 36.4347 39.9704 35.8032 39.3388L30.4999 34.0355L25.1966 39.3388C24.565 39.9704 23.6444 40.2171 22.7818 39.9859C21.919 39.7548 21.2451 39.0809 21.014 38.2181C20.7828 37.3555 21.0295 36.4349 21.661 35.8033L26.9643 30.5L21.661 25.1967C21.0295 24.5651 20.7828 23.6445 21.014 22.7819C21.2451 21.9191 21.919 21.2452 22.7818 21.0141C23.6444 20.7829 24.565 21.0296 25.1966 21.6612L30.4999 26.9645L35.8032 21.6612C36.4347 21.0296 37.3553 20.7829 38.218 21.0141C39.0807 21.2452 39.7547 21.9191 39.9857 22.7819C40.2169 23.6445 39.9703 24.5651 39.3387 25.1967Z"
                          fill="#0081FF"
                        />
                      </g>
                      <defs>
                        <clipPath id={`clip0-${name}`}>
                          <rect
                            width="60"
                            height="60"
                            fill="white"
                            transform="translate(0.5 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </Option>
                </Select>
              </InputGroup>
            </Question>
          ),
        )}
      </div>
    </ExercisePage>
  );
}
